// extracted by mini-css-extract-plugin
module.exports = {"container":"systemPart__container___2T7uY"};